import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';

import FontAwesomeIcon from '../../../components/Icons/FontAwesomeIcon';
import { TextRupiah } from '../../../components/Text';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.5;
`;

const IconWrapper = styled.div`
  margin-right: 1rem;
  font-size: 1.5rem;
`
const Balance = styled.div`
  font-size: .75rem;
`

const UserValue = props => (
  <div className="Select-value" title={props.value.email}>
    <span className="Select-value-label">
      <Wrapper>
        <IconWrapper>
          <FontAwesomeIcon iconType="user"/>
        </IconWrapper>
        <div>
          <div>
            { props.value.email }
          </div>
          {/* <Balance>
            <TextRupiah prefix="Rp. " value={props.value.balance}/>
          </Balance> */}
        </div>
      </Wrapper>
    </span>
  </div>
)

UserValue.propTypes = {
  value: propTypes.shape({
    id: propTypes.number,
    email: propTypes.string,
    balance: propTypes.string
  })
}
UserValue.defaultProps = {

}

export default UserValue;
